import { useContext, useEffect, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { EventMessage, EventType } from '@azure/msal-browser';
import { useSnackbar } from 'notistack';
import { DataLagoonContext } from 'src/DataLagoonContext';

export default function LoginSuccessToast() {
  const { instance } = useMsal();
  const { enqueueSnackbar } = useSnackbar();
  const { state } = useContext(DataLagoonContext);
  const pendingLogin = useRef(false);

  useEffect(() => {
    const callbackId = instance.addEventCallback((message: EventMessage) => {
      if (message.eventType === EventType.LOGIN_SUCCESS) {
        pendingLogin.current = true;
      } else if (message.eventType === EventType.LOGIN_FAILURE) {
        pendingLogin.current = false;
        const errorCode = (message.error as { errorCode?: string } | null)?.errorCode;
        if (errorCode !== 'user_cancelled' && errorCode !== 'popup_window_error') {
          enqueueSnackbar('Sign in failed. Please try again.', { variant: 'error' });
        }
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance, enqueueSnackbar]);

  useEffect(() => {
    const profileLoaded = !!state?.me && typeof state.me === 'object';
    if (pendingLogin.current && profileLoaded) {
      pendingLogin.current = false;
      enqueueSnackbar('Successfully signed in', { variant: 'success' });
    }
  }, [state?.me, enqueueSnackbar]);

  return null;
}
